export default function ErrorFallback({ error }) {
    return (
      <div>
        <h1>Something went wrong:</h1>
        <pre>{error.name}</pre>
        <pre>{error.message}</pre>
        <pre>{error.stack}</pre>
      </div>
    );
  }
  